import { useContext } from "react";
import { List, Button, ListItem, Divider } from "@mui/material";
import { NavLink as RouterLink } from "react-router-dom";
import { SidebarContext } from "src/contexts/SidebarContext";
import { PureLightThemeCaaS } from "src/theme/schemes/PureLightTheme";
import { MenuWrapper, SubMenuWrapper } from "src/layouts/StyleWrapper";

function SidebarMenu() {
  const { closeSidebar } = useContext(SidebarContext);

  return (
    <>
      <MenuWrapper>
        <List component="div">
          <SubMenuWrapper>
            <List component="div">
              <ListItem component="div">
                <Button disableRipple component={RouterLink} onClick={closeSidebar} to="/dashboard/home">
                  Dashboard
                </Button>
              </ListItem>
              <ListItem component="div">
                <Button disableRipple component={RouterLink} onClick={closeSidebar} to="/dashboard/usage">
                  Usage
                </Button>
              </ListItem>

              <ListItem component="div">
                <Button disableRipple component={RouterLink} onClick={closeSidebar} to="/dashboard/billing">
                  Billing
                </Button>
              </ListItem>
              <Divider
                sx={{
                  background: PureLightThemeCaaS.colors.alpha.trueWhite[30],
                  display: { lg: "none", xs: "flex" },
                  mt: 2,
                  mb: 2,
                }}
              />
              <List sx={{ display: { lg: "none", xs: "block" } }}>
                <ListItem component="div">
                  <Button disableRipple component={RouterLink} onClick={closeSidebar} to="/">
                    Home
                  </Button>
                </ListItem>
                {/* DESCOMENTAR CUANDO SE PRECISE PAGINA DE PRECIOS NUEVAMENTE */}
                {/* <ListItem component="div">
                  <Button disableRipple component={RouterLink} onClick={closeSidebar} to="/pricing">
                    Pricing
                  </Button>
                </ListItem> */}
                <ListItem component="div">
                  <Button disableRipple component={RouterLink} onClick={closeSidebar} to="/contact">
                    Contact
                  </Button>
                </ListItem>
                {/* DESCOMENTAR CUANDO SE PRECISE PAGINA DE API DOCS NUEVAMENTE */}
                {/* <ListItem component="div">
                  <Button
                    disableRipple
                    onClick={() => {
                      closeSidebar();
                      window.open(process.env.REACT_APP_API_DOCUMENTATION, "_blank");
                    }}
                  >
                    API Docs
                  </Button>
                </ListItem> */}
                <ListItem component="div">
                  <Button
                    disableRipple
                    onClick={() => {
                      closeSidebar();
                      window.open("https://chat.rotogpt.com/", "_blank");
                    }}
                  >
                    Chat
                  </Button>
                </ListItem>
              </List>
            </List>
          </SubMenuWrapper>
        </List>
      </MenuWrapper>
    </>
  );
}

export default SidebarMenu;
